import useFetch from '@hooks/useFetch';
import isEmptyObject from '@utils/isEmptyObject';

const formatData = (data) => {
  let formattedData = {};
  if (!isEmptyObject(data)) {
    let { gender, languages, availableLanguages, availableGenders } = data;

    availableLanguages = availableLanguages.map((lang) => ({
      name: lang.name,
      code: lang.languageCode,
      secondaryLanguage: lang.secondaryText
    }));

    formattedData = {
      availableGenders,
      availableLanguages,
      selectedGender: { genderCode: gender },
      selectedLanguages: [{ code: languages[0] }]
    };
  }
  return formattedData;
};

const useLMPOnboardingPreferencesInfo = (goalUID) => {
  const key = `v1/live_interaction/learner/preferences/?goal_uid=${goalUID}`;
  const { data = {}, ...rest } = useFetch(
    goalUID ? key : null,
    {},
    {
      revalidateOnMount: true
    }
  );

  const formattedData = formatData(data);

  return { lmpOnboardingPreferencesInfo: formattedData, ...rest };
};

export default useLMPOnboardingPreferencesInfo;
